var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"survey"},[(_vm.form)?_c('form-details',{attrs:{"form":_vm.form}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }